export default function CenterTable({ centers, onEdit, onLogEntry, onDailyLog, canEdit }) {
  if (centers.length === 0) {
    return (
      <div style={{
        background: "#fff", border: "1px solid #e5e5e5",
        borderRadius: 10, padding: 40,
        textAlign: "center", color: "#888", fontSize: 14,
      }}>
        No centers found. Add your first center.
      </div>
    );
  }

  return (
    <div style={{
      background: "#fff", border: "1px solid #e5e5e5",
      borderRadius: 10, overflow: "hidden",
    }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ background: "#f8f8f6", borderBottom: "1px solid #e5e5e5" }}>
            {["Name", "Address", "Hours", "Capacity", "Open", ...(canEdit ? [""] : [])].map((h) => (
              <th key={h} style={{
                textAlign: "left", padding: "10px 14px",
                fontWeight: 500, color: "#555",
                whiteSpace: "nowrap",
              }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {centers.map((c, i) => (
            <tr
              key={c.id}
              style={{
                borderBottom: i < centers.length - 1 ? "1px solid #f0f0ee" : "none",
              }}
            >
              <td style={td()}><strong>{c.name}</strong></td>
              <td style={{ ...td(), color: "#555", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {c.address}
              </td>
              <td style={td()}>{c.hours || "—"}</td>
              <td style={td()}>{c.capacity ?? "—"}</td>
              <td style={td()}>
                <span style={{
                  display: "inline-block",
                  padding: "2px 8px",
                  borderRadius: 20,
                  fontSize: 12,
                  background: c.is_open ? "#e0f3fc" : "#fdecea",
                  color: c.is_open ? "#004d74" : "#8B2020",
                }}>
                  {c.is_open ? "Open" : "Closed"}
                </span>
              </td>
              {canEdit && (
                <td style={{ ...td(), whiteSpace: "nowrap" }}>
                  <button
                    onClick={() => onEdit(c)}
                    style={actionBtn("none", "#333", "1px solid #ddd")}
                  >
                    Edit →
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const td = () => ({ padding: "10px 14px", verticalAlign: "middle" });

const actionBtn = (bg, color, border = "none") => ({
  background: bg, border, borderRadius: 6,
  padding: "4px 10px", fontSize: 12,
  cursor: "pointer", color, marginRight: 4,
});
